import { Head, Link } from "@inertiajs/react"
import { ChevronLeft } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { RedirectForm, type RedirectFormData } from "@/components/admin/RedirectForm"

export default function AdminRedirectNew({ redirect }: { redirect: RedirectFormData }) {
  return (
    <>
      <Head title="New redirect">
        <meta name="description" content="Create a 301 redirect." />
        <meta property="og:title" content="New redirect" />
        <meta property="og:description" content="Create a 301 redirect." />
      </Head>
      <AdminShell>
        <Link
          href="/admin/redirects"
          className="inline-flex items-center gap-1 text-sm text-ink-muted no-underline hover:text-ink-display"
        >
          <ChevronLeft className="h-4 w-4" />
          All redirects
        </Link>
        <div className="mt-4 border-b border-hairline pb-6">
          <h1>New redirect</h1>
        </div>
        <RedirectForm initial={redirect} />
      </AdminShell>
    </>
  )
}
